function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;


//////////////////
// WEBPACK FOOTER
// ./~/downshift/~/@babel/runtime/helpers/objectWithoutPropertiesLoose.js
// module id = 1015
// module chunks = 0